const getTagManagerId = (): string => {
  if (process.env.REACT_APP_WEBSITE === "Serenity") {
    console.log("USING SERENITY TAG MANAGER");
    return process.env.REACT_APP_GTM_SL;
  } else if (process.env.REACT_APP_WEBSITE === "Indiana") {
    console.log("USING CARDINAL TAG MANAGER");
    return process.env.REACT_APP_GTM_CR;
  } else {
    console.log("USING WINDWARDWAY TAG MANAGER");
    return process.env.REACT_APP_GTM_WWR;
  }
};

const getGoogleOptimizeId = (): string => {
  if (process.env.REACT_APP_WEBSITE === "Serenity") {
    console.log("USING SERENITY OPTIMIZE");
    return process.env.REACT_APP_EXPERIENCE_SL;
  } else if (process.env.REACT_APP_WEBSITE === "Indiana") {
    console.log("USING CARDINAL OPTIMIZE");
    return process.env.REACT_APP_EXPERIENCE_CR;
  } else {
    console.log("USING WINDWARDWAY OPTIMIZE");
    return process.env.REACT_APP_EXPERIENCE_WWR;
  }
};

const tryTagManagerId = getTagManagerId();
const tryGoogleOptimizeId = getGoogleOptimizeId();

if (!tryTagManagerId)
  throw new Error("Missing environment variable for tag manager");
if (!tryGoogleOptimizeId)
  throw new Error("Missing environment variable for google optimize");

export const tagMangerId = tryTagManagerId;
export const googleOptimizeId = tryGoogleOptimizeId;
